import 'apps/pathways/styles/app/start/headers.scss';
import React, { Fragment } from 'react';
import { Link } from 'library/util/core-router';
import { PlayButton } from 'library/components/video';
import ModalHelper from 'library/helpers/modal';
import VideoModal from 'apps/pathways/components/video-modal';

export default class HeaderZero extends React.Component {

  get modal() {
    if (!this._modal) {
      this._modal = new ModalHelper('pathways-video-modal', true, {
        className: 'pathways-video-modal'
      });
    }
    return this._modal;
  }

  closeModal = () => {
    this.modal.element.removeEventListener('click', this.handleModalClick);
    this.modal.unmount();
  }

  handleModalClick = (e) => {
    if (e.target === e.currentTarget) {
      this.closeModal();
    }
  }

  openModal = () => {
    this.modal.render(VideoModal, {
      close: this.closeModal,
      video: 'https://assets.pairin.com/videos/pathways-onboarding-overview/playlist-hls.m3u8',
      className: 'pathways-video-modal'
    });
    this.modal.element.addEventListener('click', this.handleModalClick);
  }

  componentWillUnmount() {
    this.closeModal();
  }

  render() {
    return (
      <Fragment>
        <h1>
          <small>PAIRIN</small>
          Pathways
        </h1>
        <div className="pathways-start-header-content">
          <div className="pathways-start-header-video">
            <div className="pathways-start-header-video-video">
              <span className="pathways-start-header-video-placeholder">
                <img src={`https://assets.pairin.com/videos/pathways-onboarding-overview/1280x720-00003_1080.jpg`} />
                <PlayButton onClick={this.openModal} />
              </span>
            </div>
            <div className="pathways-start-header-video-content">
              <p>By combining your Experience, Soft Skills, Education, Interests and Personal Preferences we uniquely chart a pathway to your ideal career goal.</p>
              <Link className="button" to="/pathways/start/1">GET STARTED</Link>
            </div>
          </div>
        </div>
      </Fragment>
    );
  }
}
